export default __webpack_public_path__ + "static/media/Aboutus.3335abe0.png";